import { Box, Paper, Skeleton, useTheme } from "@mui/material"

export const SkeletonNextopiaPlaceDetailCard = () => {
  const theme = useTheme()
  const { styleOverrides = {} } =
    theme.components[`NextopiaPlaceDetailCard`] || {}
  const {
    container,
    primarySection,
    secondarySection,
    innerSection,
    headerContainer,
    descriptionContainer,
    divider,
    highlightSection,
    qrCodeContainer,
    actionContainer,
  } = styleOverrides

  return (
    <Paper sx={container}>
      <Box sx={primarySection}>
        <Box sx={innerSection}>
          <Box sx={headerContainer}>
            <Skeleton variant="rounded" width="100%" height="74px" />
          </Box>
          <Skeleton sx={divider} height="8px" />
          <Box sx={descriptionContainer}>
            <Skeleton variant="rounded" width="100%" height="63px" />
          </Box>
          <Box sx={highlightSection}>
            <Skeleton variant="rounded" width="100%" height="184px" />
          </Box>
        </Box>
      </Box>
      <Box sx={secondarySection}>
        <Box sx={qrCodeContainer}>
          <Skeleton variant="rounded" width="238px" height="72px" />
        </Box>
        <Box sx={actionContainer}>
          <Skeleton variant="rounded" width="180px" height="56px" />
          <Skeleton variant="rounded" width="180px" height="56px" />
        </Box>
      </Box>
    </Paper>
  )
}
